// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'sourceSerifPro', 'sourceSerifPro Fallback'"},"className":"__className_d081cb","variable":"__variable_d081cb"};